import { useTranslate } from "../../lib/translate";

interface Props {
  compact?: boolean;
}

export default function Logo({
  compact = false,
  ...props
}: React.SVGProps<SVGSVGElement> & Props) {
  const { t } = useTranslate();
  if (compact) {
    return (
      <svg {...props} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 122 122">
        <polygon
          points="83.875 114.375 83.875 106.75 76.25 106.75 76.25 99.125 68.625 99.125 68.625 106.75 68.625 114.375 76.25 114.375 76.25 122 83.875 122 91.5 122 91.5 114.375 83.875 114.375"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="68.625"
          y="114.375"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="61 114.375 61 106.75 53.375 106.75 45.75 106.75 45.75 114.375 53.375 114.375 53.375 122 61 122 68.625 122 68.625 114.375 61 114.375"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="45.75"
          y="114.375"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="38.125 114.375 38.125 106.75 30.5 106.75 30.5 114.375 30.5 122 38.125 122 45.75 122 45.75 114.375 38.125 114.375"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="106.75"
          y="106.75"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="38.125"
          y="106.75"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="30.5 106.75 38.125 106.75 38.125 99.125 30.5 99.125 30.5 91.5 22.875 91.5 22.875 83.875 15.25 83.875 15.25 91.5 7.625 91.5 0 91.5 0 99.125 7.625 99.125 15.25 99.125 22.875 99.125 22.875 106.75 22.875 114.375 22.875 122 30.5 122 30.5 114.375 30.5 106.75"
          className="fill-current"
        />
        <path
          d="m22.875,106.75v-7.625H0v22.875h22.875v-15.25Zm-7.625,7.625h-7.625v-7.625h7.625v7.625Z"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="7.625"
          y="106.75"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <path
          d="m106.75,99.125h-7.625v22.875h22.875v-22.875h-15.25Zm7.625,15.25h-7.625v-7.625h7.625v7.625Z"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="76.25"
          y="99.125"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="38.125"
          y="99.125"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="106.75 91.5 99.125 91.5 91.5 91.5 91.5 99.125 91.5 106.75 83.875 106.75 83.875 114.375 91.5 114.375 91.5 122 99.125 122 99.125 114.375 99.125 106.75 99.125 99.125 106.75 99.125 114.375 99.125 122 99.125 122 91.5 114.375 91.5 106.75 91.5"
          className="fill-current"
        />
        <polygon
          points="83.875 83.875 76.25 83.875 76.25 91.5 76.25 99.125 83.875 99.125 83.875 106.75 91.5 106.75 91.5 99.125 91.5 91.5 83.875 91.5 83.875 83.875"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="38.125 83.875 30.5 83.875 22.875 83.875 22.875 91.5 30.5 91.5 30.5 99.125 38.125 99.125 38.125 91.5 38.125 83.875"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="15.25 91.5 15.25 83.875 7.625 83.875 7.625 76.25 15.25 76.25 15.25 83.875 22.875 83.875 22.875 76.25 30.5 76.25 30.5 68.625 22.875 68.625 22.875 61 15.25 61 15.25 68.625 7.625 68.625 7.625 61 0 61 0 68.625 0 76.25 0 83.875 0 91.5 7.625 91.5 15.25 91.5"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="106.75"
          y="76.25"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="7.625"
          y="76.25"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="114.375"
          y="68.625"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="91.5"
          y="68.625"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="7.625"
          y="61"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="114.375"
          y="53.375"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="114.375 53.375 106.75 53.375 106.75 61 99.125 61 99.125 53.375 91.5 53.375 91.5 61 83.875 61 83.875 68.625 83.875 76.25 91.5 76.25 91.5 68.625 99.125 68.625 99.125 76.25 91.5 76.25 91.5 83.875 91.5 91.5 99.125 91.5 106.75 91.5 114.375 91.5 122 91.5 122 83.875 122 76.25 114.375 76.25 114.375 83.875 106.75 83.875 106.75 76.25 114.375 76.25 114.375 68.625 122 68.625 122 61 114.375 61 114.375 53.375"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="99.125"
          y="53.375"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="7.625 61 15.25 61 15.25 53.375 22.875 53.375 22.875 45.75 15.25 45.75 15.25 38.125 15.25 30.5 7.625 30.5 0 30.5 0 38.125 7.625 38.125 7.625 45.75 0 45.75 0 53.375 7.625 53.375 7.625 61"
          className="fill-[#e1e5ed]"
        />
        <rect
          y="53.375"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="106.75"
          y="45.75"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="99.125"
          y="45.75"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="53.375 45.75 53.375 53.375 61 53.375 61 45.75 61 38.125 53.375 38.125 53.375 45.75"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="99.125"
          y="38.125"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="91.5"
          y="38.125"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <rect
          y="38.125"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="114.375"
          y="30.5"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="114.375 30.5 106.75 30.5 106.75 22.875 99.125 22.875 99.125 30.5 99.125 38.125 106.75 38.125 106.75 45.75 114.375 45.75 114.375 53.375 122 53.375 122 45.75 122 38.125 114.375 38.125 114.375 30.5"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="61"
          y="30.5"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="53.375"
          y="30.5"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="22.875"
          y="30.5"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="106.75"
          y="22.875"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="15.25 30.5 15.25 38.125 15.25 45.75 22.875 45.75 22.875 53.375 15.25 53.375 15.25 61 22.875 61 22.875 68.625 30.5 68.625 30.5 76.25 22.875 76.25 22.875 83.875 30.5 83.875 38.125 83.875 38.125 91.5 38.125 99.125 45.75 99.125 45.75 106.75 53.375 106.75 61 106.75 61 114.375 68.625 114.375 68.625 106.75 68.625 99.125 76.25 99.125 76.25 91.5 76.25 83.875 83.875 83.875 83.875 91.5 91.5 91.5 91.5 83.875 91.5 76.25 83.875 76.25 83.875 68.625 83.875 61 91.5 61 91.5 53.375 99.125 53.375 99.125 45.75 91.5 45.75 91.5 38.125 99.125 38.125 99.125 30.5 99.125 22.875 106.75 22.875 106.75 15.25 99.125 15.25 91.5 15.25 83.875 15.25 83.875 7.625 76.25 7.625 76.25 15.25 76.25 22.875 68.625 22.875 61 22.875 61 30.5 68.625 30.5 68.625 38.125 61 38.125 61 45.75 61 53.375 53.375 53.375 53.375 45.75 53.375 38.125 45.75 38.125 45.75 30.5 38.125 30.5 30.5 30.5 30.5 38.125 22.875 38.125 22.875 30.5 30.5 30.5 30.5 22.875 38.125 22.875 38.125 15.25 30.5 15.25 30.5 7.625 30.5 0 22.875 0 22.875 7.625 22.875 15.25 22.875 22.875 15.25 22.875 7.625 22.875 0 22.875 0 30.5 7.625 30.5 15.25 30.5"
          className="fill-current"
        />
        <polygon
          points="106.75 15.25 106.75 22.875 114.375 22.875 114.375 30.5 122 30.5 122 22.875 122 15.25 114.375 15.25 106.75 15.25"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="45.75"
          y="15.25"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <path
          d="m15.25,22.875h7.625V0H0v22.875h15.25ZM7.625,7.625h7.625v7.625h-7.625v-7.625Z"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="61 7.625 61 15.25 53.375 15.25 53.375 22.875 45.75 22.875 45.75 15.25 38.125 15.25 38.125 22.875 30.5 22.875 30.5 30.5 38.125 30.5 45.75 30.5 45.75 38.125 53.375 38.125 53.375 30.5 61 30.5 61 22.875 68.625 22.875 76.25 22.875 76.25 15.25 76.25 7.625 83.875 7.625 83.875 15.25 91.5 15.25 99.125 15.25 106.75 15.25 106.75 7.625 106.75 0 99.125 0 99.125 7.625 91.5 7.625 91.5 0 83.875 0 76.25 0 68.625 0 68.625 7.625 61 7.625"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="53.375"
          y="7.625"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="38.125"
          y="7.625"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <polygon
          points="30.5 15.25 38.125 15.25 38.125 7.625 45.75 7.625 45.75 15.25 53.375 15.25 53.375 7.625 61 7.625 61 0 53.375 0 45.75 0 38.125 0 30.5 0 30.5 7.625 30.5 15.25"
          className="fill-[#e1e5ed]"
        />
        <rect
          x="7.625"
          y="7.625"
          width="7.625"
          height="7.625"
          className="fill-current"
        />
        <rect
          x="114.375"
          width="7.625"
          height="7.625"
          className="fill-[#e1e5ed]"
        />
        <polygon
          points="114.375 0 106.75 0 106.75 7.625 106.75 15.25 114.375 15.25 122 15.25 122 7.625 114.375 7.625 114.375 0"
          className="fill-current"
        />
        <rect x="91.5" width="7.625" height="7.625" className="fill-current" />
        <rect x="61" width="7.625" height="7.625" className="fill-current" />
        <polygon
          points="71.14178 45.75 68.625 52.51562 62.63239 68.625 61 73.01306 57.86603 81.43774 53.375 70.01752 49.82886 61 45.75 50.62799 45.17017 49.15356 32.22198 49.15369 51.00549 96.91797 58.03058 96.91791 65.05566 96.91797 83.875 46.32806 84.09003 45.75 91.5 25.83063 91.77844 25.08209 91.5 25.08209 78.83026 25.08197 76.25 32.01819 71.14178 45.75"
          className="fill-[#477BE7]"
        />
      </svg>
    );
  }
  return (
    <svg
      aria-label={t("general.logo.alt")}
      {...props}
      width="167"
      height="41"
      viewBox="0 0 167 41"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.5 11H0L8.5 33H15.5L27.5 0H21.5L12 28L6.5 11Z"
        fill="#477BE7"
      />
      <path
        d="M36.2469 33.48C34.1935 33.48 32.3269 33.08 30.6469 32.28C28.9935 31.4533 27.6735 30.2667 26.6869 28.72C25.7269 27.1467 25.2469 25.2667 25.2469 23.08C25.2469 20.92 25.7402 19.0667 26.7269 17.52C27.7135 15.9467 28.9935 14.7467 30.5669 13.92C32.1402 13.0933 33.8069 12.68 35.5669 12.68C37.6202 12.68 39.3402 13.1067 40.7269 13.96C42.1135 14.7867 43.1535 15.92 43.8469 17.36C44.5669 18.7733 44.9269 20.3867 44.9269 22.2C44.9269 22.7333 44.8869 23.2533 44.8069 23.76C44.7535 24.24 44.7002 24.6 44.6469 24.84H29.6069V20.88H40.6869L39.7669 22C39.7669 20.4 39.4202 19.2 38.7269 18.4C38.0602 17.5733 37.0735 17.16 35.7669 17.16C34.8069 17.16 33.9669 17.3733 33.2469 17.8C32.5269 18.2267 31.9669 18.88 31.5669 19.76C31.1669 20.64 30.9669 21.7467 30.9669 23.08C30.9669 24.44 31.2069 25.56 31.6869 26.44C32.1669 27.2933 32.8602 27.9333 33.7669 28.36C34.6735 28.7867 35.7669 29 37.0469 29C37.9535 29 38.8069 28.88 39.6069 28.64C40.4335 28.4 41.2869 28.0533 42.1669 27.6L44.1269 31.16C42.9802 31.88 41.7135 32.4533 40.3269 32.88C38.9402 33.28 37.5802 33.48 36.2469 33.48ZM62.5513 33.48C60.4446 33.48 58.7646 33.12 57.5113 32.4C56.2846 31.6533 55.3913 30.6267 54.8313 29.32C54.2713 28.0133 53.9913 26.4933 53.9913 24.76V17.76H49.0313V13.4L54.2713 13.16L55.0313 7.08H59.8713V13.16H68.2713V17.76H59.8713V24.72C59.8713 25.7067 60.0179 26.5067 60.3113 27.12C60.6046 27.7333 61.0579 28.1867 61.6713 28.48C62.2846 28.7467 63.0713 28.88 64.0313 28.88C64.8046 28.88 65.5113 28.8133 66.1513 28.68C66.7913 28.5467 67.4046 28.3733 67.9913 28.16L69.0313 32.4C68.1513 32.6667 67.1779 32.9067 66.1113 33.12C65.0713 33.36 63.8846 33.48 62.5513 33.48ZM86.5356 33.48C84.429 33.48 82.749 33.12 81.4956 32.4C80.269 31.6533 79.3756 30.6267 78.8156 29.32C78.2556 28.0133 77.9756 26.4933 77.9756 24.76V17.76H73.0156V13.4L78.2556 13.16L79.0156 7.08H83.8556V13.16H92.2556V17.76H83.8556V24.72C83.8556 25.7067 84.0023 26.5067 84.2956 27.12C84.589 27.7333 85.0423 28.1867 85.6556 28.48C86.269 28.7467 87.0556 28.88 88.0156 28.88C88.789 28.88 89.4956 28.8133 90.1356 28.68C90.7756 28.5467 91.389 28.3733 91.9756 28.16L93.0156 32.4C92.1356 32.6667 91.1623 32.9067 90.0956 33.12C89.0556 33.36 87.869 33.48 86.5356 33.48ZM106.12 33V17.76H98.12V13.16H112V33H106.12ZM108.8 10.04C107.68 10.04 106.747 9.72 106 9.08C105.253 8.41333 104.88 7.54667 104.88 6.48C104.88 5.38666 105.253 4.50666 106 3.84C106.747 3.14666 107.68 2.8 108.8 2.8C109.947 2.8 110.88 3.14666 111.6 3.84C112.347 4.50666 112.72 5.38666 112.72 6.48C112.72 7.54667 112.347 8.41333 111.6 9.08C110.88 9.72 109.947 10.04 108.8 10.04ZM127.504 33V12.64C127.504 11.12 127.811 9.74666 128.424 8.52C129.064 7.26666 130.024 6.28 131.304 5.56C132.611 4.84 134.304 4.48 136.384 4.48C137.531 4.48 138.611 4.6 139.624 4.84C140.638 5.05333 141.558 5.29333 142.384 5.56L141.264 9.88C140.624 9.64 139.958 9.45333 139.264 9.32C138.598 9.18667 137.878 9.12 137.104 9.12C135.851 9.12 134.918 9.4 134.304 9.96C133.691 10.52 133.384 11.4 133.384 12.6V33H127.504ZM122.264 17.76V13.4L127.704 13.16H140.224V17.76H122.264ZM148.689 40.76C148.102 40.76 147.555 40.72 147.049 40.64C146.542 40.56 146.075 40.4667 145.649 40.36L146.689 35.88C146.955 35.96 147.222 36.0133 147.489 36.04C147.755 36.0933 148.009 36.12 148.249 36.12C149.395 36.12 150.289 35.8667 150.929 35.36C151.595 34.88 152.089 34.2667 152.409 33.52L152.809 32.48L144.209 13.16H150.049L153.369 21.68C153.742 22.6133 154.089 23.5867 154.409 24.6C154.729 25.5867 155.049 26.6 155.369 27.64H155.529C155.795 26.6533 156.089 25.6533 156.409 24.64C156.729 23.6267 157.035 22.64 157.329 21.68L160.249 13.16H165.809L157.969 33.2C157.355 34.8533 156.635 36.24 155.809 37.36C155.009 38.48 154.035 39.32 152.889 39.88C151.769 40.4667 150.369 40.76 148.689 40.76Z"
        fill="currentColor"
      />
      <path
        d="M106.891 2.94671L106.796 3.00231C104.005 4.6438 104.297 8.76941 107.291 10.0021C108.076 10.3253 108.954 10.3822 109.776 10.1692C113.503 9.20294 113.861 3.98576 110.251 2.64849C109.143 2.23811 107.909 2.34761 106.891 2.94671Z"
        fill="#FE191D"
      />
    </svg>
  );
}
